(() => {
  function placeBadges() {
    document.querySelectorAll('.product__media-wrapper').forEach(wrapper => {
      const gallery = wrapper.querySelector('media-gallery');
      if (!gallery) return;
      const viewer = gallery.querySelector('.product__media-item.is-active .product-media-container')
        || gallery.querySelector('.product-media-container');
      if (!viewer) return;
      wrapper.querySelectorAll(':scope > [data-badge-manager-overlay], media-gallery > [data-badge-manager-overlay], [id^="GalleryViewer-"] > [data-badge-manager-overlay], .product-media-container > [data-badge-manager-overlay]').forEach(overlay => {
        if (overlay.parentElement === viewer) return;
        const side = overlay.dataset.badgeManagerOverlay;
        viewer.querySelectorAll(':scope > [data-badge-manager-overlay]').forEach(existing => {
          if (existing.dataset.badgeManagerOverlay === side) existing.remove();
        });
        viewer.append(overlay);
      });
    });
  }
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    queueMicrotask(() => { pending = false; placeBadges(); });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  placeBadges();
})();
